var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AuthSessionChangedEvent, isCurrentAuthLoginAttempt } from '@/plugins/auth-storage';
import showLoading from '@/plugins/show-loading';
var active = null;
var isCurrent = function (navigation) {
    return active === navigation && isCurrentAuthLoginAttempt(navigation.attempt);
};
export var startLoginNavigation = function (router, attempt) {
    if (active)
        active.stop();
    var navigation = {
        attempt: attempt,
        route: null,
        tasks: new Map(),
        users: new Map(),
        companies: null,
        firebase: null,
        stop: function () { }
    };
    active = navigation;
    // 全画面Loadingの共有インスタンスを使わず、遷移先のローディングと分離する
    var loadingTarget = document.createElement('div');
    loadingTarget.className = 'login-navigation-loading';
    Object.assign(loadingTarget.style, {
        position: 'fixed',
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
        zIndex: '2147483647'
    });
    document.body.appendChild(loadingTarget);
    var loading = showLoading({ target: loadingTarget, fullscreen: false });
    var stopAfterEach = router.afterEach(function (to) { return __awaiter(void 0, void 0, void 0, function () {
        var failures, failure, target;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(navigation.tasks.get(to.fullPath) || [])];
                case 1:
                    failures = _a.sent();
                    if (!isCurrent(navigation) ||
                        navigation.route !== to.fullPath ||
                        router.currentRoute.fullPath !== to.fullPath)
                        return [2 /*return*/];
                    failure = failures.find(function (result) { return result !== null; });
                    if (!failure) return [3 /*break*/, 3];
                    return [4 /*yield*/, failure.handle(failure.error)];
                case 2:
                    target = _a.sent();
                    if (!isCurrent(navigation) || router.currentRoute.fullPath !== to.fullPath)
                        return [2 /*return*/];
                    if (target)
                        router.replace(target);
                    _a.label = 3;
                case 3:
                    navigation.stop();
                    return [2 /*return*/];
            }
        });
    }); });
    navigation.stop = function () {
        stopAfterEach();
        window.removeEventListener(AuthSessionChangedEvent, onSessionChanged);
        loading.close();
        loadingTarget.remove();
        if (active === navigation)
            active = null;
    };
    var onSessionChanged = function () {
        if (!isCurrent(navigation))
            navigation.stop();
    };
    window.addEventListener(AuthSessionChangedEvent, onSessionChanged);
    return navigation.stop;
};
export var getLoginNavigationGuard = function (route) {
    if (!active || !isCurrent(active))
        return null;
    var navigation = active;
    navigation.route = route.fullPath;
    return function () { return isCurrent(navigation); };
};
// 遷移先のfetch/asyncDataやmountedと並行して進め、認証と本人情報がそろうまで操作を止める
export var deferLoginNavigation = function (route, task, handle) {
    if (!active || !isCurrent(active))
        return false;
    var tasks = active.tasks.get(route.fullPath) || [];
    tasks.push(task.then(function () { return null; }, function (error) { return ({ error: error, handle: handle }); }));
    active.tasks.set(route.fullPath, tasks);
    return true;
};
export var setLoginUserRequest = function (companyId, request) {
    if (active && isCurrent(active))
        active.users.set(companyId, request);
};
export var getLoginUserRequest = function (companyId) {
    return active && isCurrent(active) ? active.users.get(companyId) : undefined;
};
export var getLoginCompaniesRequest = function () {
    return active && isCurrent(active) ? active.companies : null;
};
export var setLoginCompaniesRequest = function (request) {
    if (active && isCurrent(active))
        active.companies = request;
};
export var setLoginFirebaseRequest = function (request) {
    if (active && isCurrent(active))
        active.firebase = request;
};
export var waitForLoginFirebaseAuth = function () { return __awaiter(void 0, void 0, Promise, function () {
    var navigation, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                navigation = active;
                if (!(navigation === null || navigation === void 0 ? void 0 : navigation.firebase))
                    return [2 /*return*/, true];
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, navigation.firebase];
            case 2:
                _b.sent();
                return [2 /*return*/, isCurrentAuthLoginAttempt(navigation.attempt)];
            case 3:
                _a = _b.sent();
                // 認証失敗の表示と遷移はログイン初期化側で扱う
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };
